export class CodigoUnidadeSigad {
  codigo: string

  constructor(codigo: string) {
    this.codigo = this.tranformarCodigo(codigo)
  }

  tranformarCodigo(codigo: string): string {
    const niveis: string[] = codigo.split('.')

    if (!niveis?.length) {
      throw new Error('Código de unidade inválido, deve possui pelo menos 1 nível.')
    }

    if (niveis.some(nivel => isNaN(parseInt(nivel)))) {
      throw new Error('Código de unidade inválido, todos os níveis devem ser um valor numérico.')
    }

    const niveisPreenchidos: string[] = niveis.map(nivel => String(parseInt(nivel)).padStart(2, '0'))

    while (niveisPreenchidos.length < 7) {
      niveisPreenchidos.push('00')
    }

    return niveisPreenchidos.join('.')
  }

  getNiveis(): string[] {
    return this.codigo.split('.')
  }

  comparar(codigoParaComparar: CodigoUnidadeSigad, ateNivel: number): boolean {
    const niveis = this.getNiveis()
    const niveisComparar = codigoParaComparar.getNiveis()

    for (let i = 0; i < ateNivel; i++) {
      if (niveis[i] !== niveisComparar[i]) {
        return false
      }
    }

    return true
  }

  toString(): string {
    return this.codigo
  }
}
